    // ── Header search: submit immediately, even before Searchanise finishes loading ──
    function nwSubmitSearchanise(form) {
        var input = form && form.querySelector('input[name="q"]');
        var query = input && input.value ? input.value.trim() : '';
        if (!query) {
            if (input) input.focus();
            return;
        }
        window.location.assign('/pages/search-results-page?q=' + encodeURIComponent(query));
    }

    document.addEventListener('submit', function(event) {
        var form = event.target;
        if (!form || !form.matches || !form.matches('.nw-header-search, .nw-search-form, .nw-mobile-search-form')) return;
        event.preventDefault();
        nwSubmitSearchanise(form);
    }, true);

    document.addEventListener('keydown', function(event) {
        if (event.key !== 'Enter') return;
        var input = event.target;
        if (!input || !input.matches || !input.matches('.nw-header-search__input, .nw-search-input, .nw-mobile-search-input')) return;
        var form = input.closest('form');
        if (!form) return;
        event.preventDefault();
        nwSubmitSearchanise(form);
    }, true);

    // ── Header search: bind the Searchanise dropdown to the injected input ──
    // The desktop input is built by nwInjectHeaderRight after Searchanise has
    // already scanned the page, so it never gets the autocomplete. Re-run
    // Searchanise.Start() the first time it is used. This used to live in the
    // Searchanise admin Custom JS behind a hardcoded theme ID, which broke on
    // every duplicated sale theme. Capture phase so the handlers Start() binds
    // on the input still fire for this same click.
    function nwBindHeaderSearchanise(event) {
        var input = event.target;
        if (!input || !input.matches || !input.matches('.nw-header-search__input')) return;
        if (input.classList.contains('snize-input-style')) return;
        if (window.Searchanise && typeof window.Searchanise.Start === 'function') window.Searchanise.Start();
    }
    document.addEventListener('click', nwBindHeaderSearchanise, true);
    document.addEventListener('focusin', nwBindHeaderSearchanise, true);

    // ── Searchanise full-width fix (all screen sizes) ──
    var nwSnizeRevealTimer = null;
    var nwSnizeRevealed = false;
    function nwSnizeReveal() {
        if (nwSnizeRevealed) return;
        nwSnizeRevealed = true;
        var section = document.getElementById('shopify-section-searchanise-navigation') || document.getElementById('shopify-section-17743000362d6feb52');
        if (section) section.classList.add('nw-snize-ready');
    }

    // Force the section container and snize_results to always be 100% wide,
    // regardless of what Searchanize's JS sets via inline styles.
    function nwSnizeForceFullWidth() {
        var section = document.getElementById('shopify-section-searchanise-navigation');
        if (section) {
            section.style.setProperty('width', '100%', 'important');
            section.style.setProperty('max-width', '100%', 'important');
            section.style.setProperty('padding-inline', '0', 'important');
            section.style.setProperty('margin-inline', '0', 'important');
            section.style.setProperty('box-sizing', 'border-box', 'important');
        }
        var results = document.getElementById('snize_results');
        if (results) {
            results.style.setProperty('width', '100%', 'important');
            results.style.setProperty('max-width', '100%', 'important');
            results.style.setProperty('box-sizing', 'border-box', 'important');
            var inner = results.querySelector('.snize-main-panel');
            if (inner) {
                inner.style.setProperty('width', '100%', 'important');
                inner.style.setProperty('max-width', '100%', 'important');
                inner.style.setProperty('box-sizing', 'border-box', 'important');
            }
            // Hide view-toggle button and product count header
            [
                'snize-main-panel-view-mode',
                'snize-view-mode-grid',
                'snize-view-mode-list',
                'snize-view-mode-icon',
                'snize-search-results-header'
            ].forEach(function(cls) {
                results.querySelectorAll('.' + cls).forEach(function(el) {
                    el.style.setProperty('display', 'none', 'important');
                });
            });
            // Fix FILTERS button right spacing — find its actual parent bar and pad it
            var filtersBtn = results.querySelector('.snize-main-panel-mobile-filters');
            if (filtersBtn) {
                filtersBtn.style.setProperty('margin-right', '20px', 'important');
                var bar = filtersBtn.parentElement;
                if (bar) {
                    bar.style.setProperty('padding-right', '20px', 'important');
                    bar.style.setProperty('box-sizing', 'border-box', 'important');
                }
            }
        }
    }

    function nwFixSortLabel() {
        if (window.innerWidth >= 750) return;
        var results = document.getElementById('snize_results');
        if (!results) return;
        var span = results.querySelector('.snize-main-panel-dropdown-button span');
        if (span) span.textContent = 'SORT';
    }

    var nwSnizePaginationNormalizing = false;
    function nwNormalizeSnizePagination() {
        if (nwSnizePaginationNormalizing) return;
        var root = document.getElementById('snize_results');
        if (!root) return;

        nwSnizePaginationNormalizing = true;
        try {
        root.querySelectorAll('.nw-snize-mobile-pagination').forEach(function(pagination) {
            pagination.classList.remove('nw-snize-mobile-pagination');
        });
        root.querySelectorAll('.nw-snize-page-count').forEach(function(count) {
            count.remove();
        });
        root.querySelectorAll('.nw-snize-page-number-row').forEach(function(row) {
            Array.prototype.slice.call(row.childNodes).forEach(function(child) {
                row.parentNode.insertBefore(child, row);
            });
            row.remove();
        });

        var paginations = Array.prototype.slice.call(root.querySelectorAll('[class*="pagination"], [id*="pagination"]'));
        paginations.forEach(function(pagination) {
            var controls = Array.prototype.slice.call(pagination.querySelectorAll('a, button, span')).filter(function(control) {
                return control.textContent && control.textContent.trim();
            });
            if (!controls.length) return;

            var prevControl = controls.find(function(control) {
                var className = String(control.className || '') + ' ' + String(control.parentElement && control.parentElement.className || '');
                return /previous|prev/i.test(control.textContent) || /prev/i.test(className) || /[‹«←]/.test(control.textContent.trim());
            });
            var nextControl = controls.find(function(control) {
                var className = String(control.className || '') + ' ' + String(control.parentElement && control.parentElement.className || '');
                return /next/i.test(control.textContent) || /next/i.test(className) || /[›»→]/.test(control.textContent.trim());
            });
            var numericControls = controls.filter(function(control) {
                return /^\d+$/.test(control.textContent.trim());
            });
            var pageControls = controls.filter(function(control) {
                return /^\d+$/.test(control.textContent.trim()) || /^(\.{2,}|…)$/.test(control.textContent.trim());
            });

            if ((!prevControl || !nextControl) && numericControls.length < 2) return;

            var currentControl = controls.find(function(control) {
                var className = String(control.className || '') + ' ' + String(control.parentElement && control.parentElement.className || '');
                return control.getAttribute('aria-current') || /\b(active|current)\b/i.test(className);
            });
            var currentPage = currentControl && parseInt(currentControl.textContent.trim(), 10);
            if (!currentPage) {
                currentPage = parseInt(new URLSearchParams(window.location.search).get('page') || '1', 10);
            }

            var totalPages = numericControls.reduce(function(max, control) {
                var value = parseInt(control.textContent.trim(), 10);
                return value > max ? value : max;
            }, currentPage || 1);

            var prevShell = prevControl && (prevControl.closest('li') || prevControl);
            var nextShell = nextControl && (nextControl.closest('li') || nextControl);
            var targetPagination = pagination;
            if (prevShell && nextShell && prevShell.parentElement === nextShell.parentElement) {
                targetPagination = prevShell.parentElement;
            }

            targetPagination.classList.add('nw-snize-mobile-pagination');

            var count = document.createElement(/^(UL|OL)$/i.test(targetPagination.tagName) ? 'li' : 'span');
            count.className = 'nw-snize-page-count';
            count.textContent = (currentPage || 1) + ' of ' + totalPages;
            targetPagination.insertBefore(count, targetPagination.firstChild);

            var pageRow = document.createElement(/^(UL|OL)$/i.test(targetPagination.tagName) ? 'li' : 'span');
            pageRow.className = 'nw-snize-page-number-row';
            targetPagination.insertBefore(pageRow, count.nextSibling);

            function markControl(control, className, label) {
                if (!control) return;
                var shell = control.closest('li') || control;
                shell.classList.add(className);
                control.classList.add(className + '-control');
                if (/^[‹«←›»→]$/.test(control.textContent.trim())) {
                    control.textContent = label;
                }
            }

            markControl(prevControl, 'nw-snize-page-prev', 'Previous');
            markControl(nextControl, 'nw-snize-page-next', 'Next');

            pageControls.forEach(function(control) {
                var shell = control.closest('li') || control;
                shell.classList.add('nw-snize-page-link');
                pageRow.appendChild(shell);
            });
        });
        } finally {
            setTimeout(function() {
                nwSnizePaginationNormalizing = false;
            }, 0);
        }
    }

    // Run at multiple delays to catch all phases of Searchanize init
    document.addEventListener('DOMContentLoaded', function() {
        if (!document.getElementById('snize_results') &&
            !document.getElementById('shopify-section-searchanise-navigation') &&
            !document.getElementById('shopify-section-17743000362d6feb52')) return;
        [0, 200, 500, 1000, 2000, 4000].forEach(function(d) {
            setTimeout(nwSnizeForceFullWidth, d);
            setTimeout(nwFixSortLabel, d);
            setTimeout(nwNormalizeSnizePagination, d);
        });
        // MutationObserver: re-apply when Searchanise mutates #snize_results attributes
        var results = document.getElementById('snize_results');
        if (results) {
            new MutationObserver(function() {
                nwSnizeForceFullWidth();
                nwFixSortLabel();
                nwNormalizeSnizePagination();
            }).observe(results, { attributes: true, attributeFilter: ['style', 'class'], childList: true, subtree: true });
        }
    });

    document.addEventListener('Searchanise.ResultsUpdated', nwNormalizeSnizePagination);
    document.addEventListener('Searchanise.Loaded', function() {
        if (window.Searchanise && window.Searchanise.$) {
            window.Searchanise.$(document).on('Searchanise.ResultsUpdated', nwNormalizeSnizePagination);
        }
        nwNormalizeSnizePagination();
    });
    window.addEventListener('resize', nwNormalizeSnizePagination);

    function nwSnizeApplyFix() {
        if (window.innerWidth >= 750) return;
        var results = document.querySelector('#snize_results');
        if (!results) return;

        var appBlock = results.closest('.shopify-app-block');
        if (appBlock) {
            appBlock.style.setProperty('width', '100%', 'important');
            appBlock.style.setProperty('max-width', '100%', 'important');
            appBlock.style.setProperty('min-width', '0', 'important');
            appBlock.style.setProperty('align-self', 'stretch', 'important');
            var layoutPanel = appBlock.parentElement;
            if (layoutPanel) layoutPanel.style.setProperty('align-items', 'stretch', 'important');
        }

        results.style.setProperty('width', '100%', 'important');
        results.style.setProperty('max-width', '100%', 'important');
        results.style.setProperty('box-sizing', 'border-box', 'important');

        var ul = results.querySelector('ul.snize-search-results-content');
        if (ul) {
            ul.style.setProperty('width', '100%', 'important');
            ul.style.setProperty('max-width', '100%', 'important');
            ul.style.setProperty('margin-left', '0', 'important');
            ul.style.setProperty('margin-right', '0', 'important');
        }

        results.querySelectorAll('ul.snize-search-results-content > li').forEach(function(li) {
            li.style.setProperty('width', '50%', 'important');
            li.style.setProperty('max-width', '50%', 'important');
            li.style.setProperty('flex', '0 0 50%', 'important');
            li.style.setProperty('box-sizing', 'border-box', 'important');
        });

        // Debounced reveal: show content 400ms after the last fix fires
        // (resets the timer if Searchanise re-overrides and triggers another fix)
        if (!nwSnizeRevealed) {
            clearTimeout(nwSnizeRevealTimer);
            nwSnizeRevealTimer = setTimeout(nwSnizeReveal, 400);
        }
    }

    function nwSnizeIsFixed() {
        var results = document.querySelector('#snize_results');
        if (!results) return false;
        // appBlock must have width: 100% (not a pixel value from Searchanise)
        var appBlock = results.closest('.shopify-app-block');
        if (appBlock && appBlock.style.width !== '100%') return false;
        // #snize_results must also be at 100%
        if (results.style.width !== '100%') return false;
        // li items must be at 50% !important
        var li = results.querySelector('ul.snize-search-results-content > li');
        return li && li.style.width === '50%' && li.style.getPropertyPriority('width') === 'important';
    }

    var nwSnizeInitStartedAt = null;
    var nwSnizeInitTimeoutMs = 15000;
    var nwSnizeInitTimeoutWarned = false;

    function nwSnizeInit() {
        if (window.innerWidth >= 750) return;
        if (nwSnizeInitStartedAt === null) nwSnizeInitStartedAt = Date.now();
        var results = document.querySelector('#snize_results');
        if (!results) {
            if (Date.now() - nwSnizeInitStartedAt >= nwSnizeInitTimeoutMs) {
                if (!nwSnizeInitTimeoutWarned &&
                    (document.getElementById('shopify-section-searchanise-navigation') ||
                    document.getElementById('shopify-section-17743000362d6feb52')) &&
                    window.console && window.console.warn) {
                    nwSnizeInitTimeoutWarned = true;
                    window.console.warn('Searchanise mobile layout retry timed out waiting for #snize_results.');
                }
                return;
            }
            setTimeout(nwSnizeInit, 300);
            return;
        }
        nwSnizeInitStartedAt = null;
        nwSnizeInitTimeoutWarned = false;

        // Apply immediately and at staggered delays to catch all Searchanise init phases
        [0, 200, 500, 1000, 2000, 4000].forEach(function(d) { setTimeout(nwSnizeApplyFix, d); });

        // Fallback: always reveal after 2s regardless of fix status
        setTimeout(nwSnizeReveal, 2000);

        var appBlock = results.closest('.shopify-app-block');
        var layoutPanel = appBlock && appBlock.parentElement;

        // MutationObserver: watches results, appBlock, and layoutPanel for any style revert
        var observer = new MutationObserver(function() {
            if (!nwSnizeIsFixed()) nwSnizeApplyFix();
        });
        observer.observe(results, { attributes: true, attributeFilter: ['style'], subtree: true, childList: true });
        if (appBlock) observer.observe(appBlock, { attributes: true, attributeFilter: ['style'] });
        if (layoutPanel) observer.observe(layoutPanel, { attributes: true, attributeFilter: ['style'] });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', nwSnizeInit);
    } else {
        nwSnizeInit();
    }

    function moveElementToSizeVariant() {
        const sizeVariantOption = document.querySelector('.product-information variant-picker .variant-option.variant-option--size');
        
        if (!sizeVariantOption) {
            return;
        }
        
        // Check if elements are already moved (to avoid moving them multiple times)
        const existingFitQuiz = sizeVariantOption.querySelector('.shopify-block.shopify-app-block.fit-quiz-wrapper');
        const existingEsRecommended = sizeVariantOption.querySelector('.es-recommended');
        const existingEasysize = sizeVariantOption.querySelector('#easysize_button');
        
        // Move fit-quiz-wrapper if it exists and hasn't been moved yet
        if (!existingFitQuiz) {
            const fitQuizWrapper = document.querySelector('.product-information .shopify-block.shopify-app-block.fit-quiz-wrapper');
            if (fitQuizWrapper && !fitQuizWrapper.closest('.variant-option')) {
                sizeVariantOption.appendChild(fitQuizWrapper);
            }
        }
        
        // Move es-recommended if it exists and hasn't been moved yet
        if (!existingEsRecommended) {
            // First check if it's a direct sibling of variant-picker
            const variantPicker = document.querySelector('.product-information variant-picker');
            let esRecommended = null;
            
            if (variantPicker) {
                const nextSibling = variantPicker.nextElementSibling;
                if (nextSibling instanceof HTMLElement && 
                    nextSibling.tagName === 'P' && 
                    nextSibling.classList.contains('es-recommended')) {
                    esRecommended = nextSibling;
                }
            }
            
            // Fallback: search in product-information area
            if (!esRecommended) {
                esRecommended = document.querySelector('.product-information .es-recommended');
            }
            
            if (esRecommended && !esRecommended.closest('.variant-option')) {
                sizeVariantOption.appendChild(esRecommended);
            }
        }
        
        // Move easysize button if fit-quiz-wrapper and es-recommended are not found
        if (!existingFitQuiz && !existingEsRecommended && !existingEasysize) {
            const easysizeButton = document.querySelector('.product-information #easysize_button');
            
            if (easysizeButton && !easysizeButton.closest('.variant-option')) {
                const isHidden = window.getComputedStyle(easysizeButton).display === 'none';
                
                if (!isHidden) {
                    sizeVariantOption.appendChild(easysizeButton);
                }
            }
        }
    }

    // Native lightbox for product media (desktop only — mobile uses native swipe slideshow)
    function initNativeLightbox() {
        var lb = document.getElementById('nw-lightbox');
        if (!lb) {
            lb = document.createElement('div');
            lb.id = 'nw-lightbox';
            lb.setAttribute('aria-hidden', 'true');
            lb.innerHTML =
                '<img class="nw-lb-img" src="" alt="">' +
                '<button class="nw-lb-close" aria-label="Close">\u00d7</button>' +
                '<button class="nw-lb-prev" aria-label="Previous">\u2039</button>' +
                '<button class="nw-lb-next" aria-label="Next">\u203a</button>' +
                '<div class="nw-lb-counter"></div>';
            document.body.appendChild(lb);

            var lbImg = lb.querySelector('.nw-lb-img');
            var lbClose = lb.querySelector('.nw-lb-close');
            var lbPrev = lb.querySelector('.nw-lb-prev');
            var lbNext = lb.querySelector('.nw-lb-next');
            var lbCounter = lb.querySelector('.nw-lb-counter');
            var gallery = [];
            var current = 0;

            function show(idx) {
                current = (idx + gallery.length) % gallery.length;
                lbImg.classList.add('nw-lb-loading');
                var tmp = new Image();
                tmp.onload = function() {
                    lbImg.src = tmp.src;
                    lbImg.alt = gallery[current].alt;
                    lbImg.classList.remove('nw-lb-loading');
                };
                tmp.src = gallery[current].src;
                lbCounter.textContent = gallery.length > 1 ? (current + 1) + ' / ' + gallery.length : '';
                lbPrev.style.display = gallery.length > 1 ? '' : 'none';
                lbNext.style.display = gallery.length > 1 ? '' : 'none';
            }

            lb._open = function(items, idx) {
                gallery = items;
                show(idx);
                lb.setAttribute('aria-hidden', 'false');
                lb.classList.add('nw-lb-open');
                document.body.style.overflow = 'hidden';
            };

            function close() {
                lb.classList.remove('nw-lb-open');
                lb.setAttribute('aria-hidden', 'true');
                document.body.style.overflow = '';
            }

            lbClose.addEventListener('click', close);
            lbPrev.addEventListener('click', function(e) { e.stopPropagation(); show(current - 1); });
            lbNext.addEventListener('click', function(e) { e.stopPropagation(); show(current + 1); });
            lb.addEventListener('click', function(e) { if (e.target === lb) close(); });
            document.addEventListener('keydown', function(e) {
                if (!lb.classList.contains('nw-lb-open')) return;
                if (e.key === 'Escape') close();
                if (e.key === 'ArrowLeft') show(current - 1);
                if (e.key === 'ArrowRight') show(current + 1);
            });
        }

        if (window.innerWidth < 750) return;

        var galleryItems = [];
        document.querySelectorAll("[data-fancybox^='product-gallery--mobile']:not([hidden])").forEach(function(el) {
            if (!el.dataset.lbInit) {
                el.dataset.lbInit = '1';
                galleryItems.push({ el: el, src: el.getAttribute('data-src'), alt: el.getAttribute('data-image-alt') || '' });
            }
        });

        galleryItems.forEach(function(item, idx) {
            item.el.addEventListener('click', function(e) {
                if (!item.src) return;
                e.preventDefault();
                e.stopPropagation();
                lb._open(galleryItems, idx);
            });
        });
    }

    // In-place zoom for desktop product gallery grid
    // Uses the full-res background-image Shopify sets inline on .zoom divs
    function initGalleryInPlaceZoom() {
        if (window.innerWidth < 750) return;

        const gallerySelector = '.product-information__media .media-gallery__grid';
        const imageContainerSelector = '.product-media-container--image';

        function setZoomPosition(item, zoomSurface, e) {
            var rect = item.getBoundingClientRect();
            var x = ((e.clientX - rect.left) / rect.width) * 100;
            var y = ((e.clientY - rect.top) / rect.height) * 100;
            zoomSurface.style.setProperty('background-position', x + '% ' + y + '%', 'important');
        }

        function getSharperZoomSrc(src) {
            if (!src) return '';

            if (/([?&])width=\d+/.test(src)) {
                return src.replace(/([?&])width=\d+/, '$1width=1400');
            }

            return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=1400';
        }

        function getZoomLayer(item) {
            var layer = item.querySelector(':scope > .nw-desktop-zoom-layer');
            if (layer) return layer;

            layer = document.createElement('div');
            layer.className = 'nw-desktop-zoom-layer';
            layer.setAttribute('aria-hidden', 'true');
            item.appendChild(layer);
            return layer;
        }

        function loadZoomImage(item) {
            var zoomSurface = item.querySelector('img');
            if (!zoomSurface) return Promise.resolve('');

            var sharperSrc = getSharperZoomSrc(zoomSurface.currentSrc || zoomSurface.src);
            if (!sharperSrc) return Promise.resolve('');

            if (item._nwZoomPreloadSrc === sharperSrc && item._nwZoomPreloadPromise) {
                return item._nwZoomPreloadPromise;
            }

            item._nwZoomPreloadSrc = sharperSrc;
            item._nwZoomPreloadPromise = new Promise(function(resolve) {
                var preloadImage = new Image();
                var finish = function() {
                    resolve(sharperSrc);
                };

                preloadImage.decoding = 'async';
                preloadImage.onload = finish;
                preloadImage.onerror = finish;
                preloadImage.src = sharperSrc;
            });

            return item._nwZoomPreloadPromise;
        }

        function prewarmZoomImage(item) {
            loadZoomImage(item);
        }

        function applyZoom(item, e) {
            var layer = getZoomLayer(item);
            item.classList.add('is-zoom-loading');

            loadZoomImage(item).then(function(sharperSrc) {
                if (!item.classList.contains('is-zoomed')) return;
                if (!sharperSrc) return;

                layer.style.setProperty('background-image', 'url("' + sharperSrc + '")', 'important');
                setZoomPosition(item, layer, e);
                item.classList.remove('is-zoom-loading');
                item.classList.add('is-zoom-ready');
            });
        }

        function openZoom(item, e) {
            item.classList.add('is-zoomed');
            applyZoom(item, e);
        }

        function clearZoom(item) {
            var layer = getZoomLayer(item);

            item.classList.remove('is-zoom-loading', 'is-zoom-ready');
            layer.style.removeProperty('background-position');
        }

        if (!document.documentElement.dataset.nwDesktopZoomDelegateV2) {
            document.documentElement.dataset.nwDesktopZoomDelegateV2 = '1';

            document.addEventListener('click', function(e) {
                if (window.innerWidth < 750) return;

                var item = e.target.closest(gallerySelector + ' ' + imageContainerSelector);
                if (!item) return;

                e.preventDefault();
                e.stopPropagation();

                if (item.classList.contains('is-zoomed')) {
                    item.classList.remove('is-zoomed', 'is-zoom-ready');
                    clearZoom(item);
                } else {
                    document.querySelectorAll(gallerySelector + ' ' + imageContainerSelector + '.is-zoomed').forEach(function(openItem) {
                        if (openItem !== item) {
                            openItem.classList.remove('is-zoomed', 'is-zoom-ready');
                            clearZoom(openItem);
                        }
                    });
                    openZoom(item, e);
                }
            }, true);

            document.addEventListener('pointermove', function(e) {
                if (window.innerWidth < 750) return;

                var item = e.target.closest(gallerySelector + ' ' + imageContainerSelector + '.is-zoomed');
                if (!item) return;

                var layer = item.querySelector(':scope > .nw-desktop-zoom-layer');
                if (layer) setZoomPosition(item, layer, e);
            }, true);
        }

        const items = document.querySelectorAll(gallerySelector + ' ' + imageContainerSelector);

        items.forEach(function(item) {
            if (item.dataset.zoomInit) return;
            item.dataset.zoomInit = '1';
            item.dataset.nwZoomSrc = item.getAttribute('data-src') || item.dataset.nwZoomSrc || '';

            // Remove fancybox attributes so it doesn't open a lightbox on click
            item.removeAttribute('data-fancybox');
            item.removeAttribute('data-src');

            var img = item.querySelector('img');
            if (img && !img.dataset.nwZoomObserved) {
                img.dataset.nwZoomObserved = '1';
                new MutationObserver(function() {
                    if (!item.classList.contains('is-zoomed')) return;
                    item.classList.remove('is-zoomed', 'is-zoom-ready');
                    clearZoom(item);
                }).observe(img, {
                    attributes: true,
                    attributeFilter: ['src', 'srcset', 'data_max_resolution']
                });
            }

            item.addEventListener('mouseenter', function() {
                prewarmZoomImage(item);
            });

            item.addEventListener('focusin', function() {
                prewarmZoomImage(item);
            });

            item.addEventListener('mousemove', function(e) {
                if (!this.classList.contains('is-zoomed')) return;
                var layer = item.querySelector(':scope > .nw-desktop-zoom-layer');
                if (layer) setZoomPosition(item, layer, e);
            });

            item.addEventListener('mouseleave', function() {
                this.classList.remove('is-zoomed', 'is-zoom-ready');
                clearZoom(item);
            });
        });
    }

    // Hide progress dots for hidden variant slides on mobile,
    // and remap aria-selected to the correct visible dot.
    function syncMobileDots() {
        if (window.innerWidth >= 750) return;

        const slideshow = document.querySelector('.product-information__media slideshow-component');
        if (!slideshow) return;

        const slides = Array.from(slideshow.querySelectorAll('slideshow-slide'));
        const dotItems = Array.from(slideshow.querySelectorAll('.media-gallery__mobile-controls .slideshow-controls__dots li'));
        const dotButtons = Array.from(slideshow.querySelectorAll('.media-gallery__mobile-controls .slideshow-controls__dots button'));

        if (!slides.length || !dotItems.length) return;

        // Disconnect old observers before rebuilding
        if (slideshow._ariaObserver) slideshow._ariaObserver.disconnect();
        if (slideshow._hiddenObserver) slideshow._hiddenObserver.disconnect();

        // Build filteredToTotal: maps filteredIndex → totalIndex for visible slides
        const filteredToTotal = [];
        slides.forEach(function(slide, i) {
            var hidden = slide.hasAttribute('hidden');
            if (!hidden) filteredToTotal.push(i);
            if (dotItems[i]) dotItems[i].style.display = hidden ? 'none' : '';
        });

        // Remap aria-selected: slideshow uses filtered index but dots use total index
        var remapping = false;
        slideshow._ariaObserver = new MutationObserver(function() {
            if (remapping) return;
            var selectedIdx = -1;
            dotButtons.forEach(function(btn, i) {
                if (btn.getAttribute('aria-selected') === 'true') selectedIdx = i;
            });
            if (selectedIdx < 0) return;
            var correctTotal = filteredToTotal[selectedIdx];
            if (correctTotal === undefined || correctTotal === selectedIdx) return;
            remapping = true;
            dotButtons.forEach(function(btn, i) {
                btn.setAttribute('aria-selected', String(i === correctTotal));
            });
            setTimeout(function() { remapping = false; }, 0);
        });
        slideshow._ariaObserver.observe(slideshow, {
            attributes: true, attributeFilter: ['aria-selected'], subtree: true
        });

        // Re-sync immediately when the theme hides/shows slides on variant change
        slideshow._hiddenObserver = new MutationObserver(function(mutations) {
            var relevant = mutations.some(function(m) {
                return m.target.tagName && m.target.tagName.toLowerCase() === 'slideshow-slide';
            });
            if (relevant) {
                slideshow._ariaObserver.disconnect();
                slideshow._hiddenObserver.disconnect();
                syncMobileDots();
            }
        });
        slideshow._hiddenObserver.observe(slideshow, {
            attributes: true, attributeFilter: ['hidden'], subtree: true
        });
    }

    function applyStarFilter(el, isMobile) {
        if (isMobile) {
            el.style.setProperty('-webkit-filter', 'brightness(0)', 'important');
            el.style.setProperty('filter', 'brightness(0)', 'important');
        } else {
            el.style.removeProperty('-webkit-filter');
            el.style.removeProperty('filter');
        }
    }

    function fixYotpoCardStars() {
        var isMobile = window.innerWidth < 750;

        // Stars live in .snize-reviews — black on all screen sizes
        var snize = document.getElementById('snize_results');
        if (snize) {
            snize.querySelectorAll('.snize-reviews').forEach(function(el) {
                applyStarFilter(el, true);
                // Show review count (overrides Searchanise's display:none)
                var count = el.querySelector('.total-reviews');
                if (count) {
                    count.style.setProperty('display', 'inline-block', 'important');
                    count.style.setProperty('font-size', '10px', 'important');
                    count.style.setProperty('line-height', 'normal', 'important');
                    count.style.setProperty('margin-left', '5px', 'important');
                }
            });
        }

        document.querySelectorAll('.nw-yotpo-card-stars').forEach(function(widget) {
            var productInfo = widget.closest('.product-information');
            // Hide widget entirely if 0 reviews
            var rightPanel = widget.querySelector('.yotpo-sr-bottom-line-right-panel');
            var isEmptyLoadedWidget =
                widget.hasAttribute('data-yotpo-element-loaded') &&
                !widget.querySelector('.yotpo-sr-bottom-line-button') &&
                !widget.textContent.trim();

            if ((rightPanel && /^\s*0\s/i.test(rightPanel.textContent)) || isEmptyLoadedWidget) {
                widget.style.setProperty('display', 'none', 'important');
                if (productInfo) productInfo.classList.add('nw-product-no-review-stars');
                return;
            }
            if (productInfo) productInfo.classList.remove('nw-product-no-review-stars');
            // Remove Yotpo's internal margin/padding
            widget.querySelectorAll('.yotpo-reviews-star-ratings-widget, .yotpo-widget-clear, .yotpo-bottom-line-scroll-panel').forEach(function(el) {
                el.style.setProperty('margin', '0', 'important');
                el.style.setProperty('padding', '0', 'important');
            });
            // Hide score number and separator
            widget.querySelectorAll('.yotpo-sr-bottom-line-score, .yotpo-sr-bottom-line-left-panel, .yotpo-sr-vertical-border').forEach(function(el) {
                el.style.setProperty('display', 'none', 'important');
            });
            // Fix button layout
            var btn = widget.querySelector('.yotpo-sr-bottom-line-button');
            if (btn) {
                btn.style.setProperty('display', 'flex', 'important');
                btn.style.setProperty('align-items', 'center', 'important');
                btn.style.setProperty('gap', '4px', 'important');
                btn.style.setProperty('padding', '0', 'important');
                btn.style.setProperty('height', 'auto', 'important');
            }
            // Shrink star SVGs
            widget.querySelectorAll('.yotpo-sr-bottom-line-button [aria-hidden="true"] svg').forEach(function(el) {
                el.style.setProperty('width', '12px', 'important');
                el.style.setProperty('height', '12px', 'important');
                el.style.setProperty('margin-inline-end', '2px', 'important');
            });
            // Apply filter to the wrapper and any Yotpo widget inside it
            applyStarFilter(widget, isMobile);
            widget.querySelectorAll('.yotpo-reviews-star-ratings-widget, .yotpo.bottomLine').forEach(function(el) {
                applyStarFilter(el, isMobile);
            });
            // Review count — ensure visible and styled
            var rp = widget.querySelector('.yotpo-sr-bottom-line-right-panel');
            if (rp) {
                rp.style.setProperty('display', 'inline-flex', 'important');
                rp.style.setProperty('align-items', 'center', 'important');
                rp.style.setProperty('font-size', '11px', 'important');
                rp.style.setProperty('font-weight', '400', 'important');
                rp.style.setProperty('font-family', 'inherit', 'important');
                rp.style.setProperty('color', 'inherit', 'important');
                rp.style.setProperty('margin-left', '4px', 'important');
                rp.querySelectorAll('*').forEach(function(el) {
                    el.style.setProperty('font-size', '11px', 'important');
                    el.style.setProperty('color', 'inherit', 'important');
                });
            }
        });
    }

    function fixProductInfoReviewState() {
        document.querySelectorAll('.product-information').forEach(function(productInfo) {
            var reviewWidget = productInfo.querySelector('.nw-yotpo-card-stars, .yotpo-reviews-star-ratings-widget');
            var visibleReviewWidget = reviewWidget && reviewWidget.getBoundingClientRect().height > 0;
            var reviewText = reviewWidget ? reviewWidget.textContent.trim() : '';
            var hasReviewContent = visibleReviewWidget && reviewText && !/^\s*0\s/i.test(reviewText);

            productInfo.classList.toggle('nw-product-no-review-stars', !hasReviewContent);
        });
    }

    function fixSnizeAlignment() {
        if (window.innerWidth >= 750) return;
        document.querySelectorAll('#snize_results li.snize-product .snize-overhidden').forEach(function(el) {
            el.style.setProperty('padding', '5px 0px 0px 3px', 'important');
        });
        document.querySelectorAll('#snize_results li.snize-product .snize-overhidden, #snize_results li.snize-product .snize-overhidden *').forEach(function(el) {
            el.style.setProperty('text-align', 'left', 'important');
        });
    }

    // ── "New" badge: fetch products tagged 'New' once, then inject badge on matching cards ──
    var nwNewHandlesFetched = false;

    function injectNewBadges() {
        var snize = document.getElementById('snize_results');
        if (!snize || !window.nwNewProductHandles) return;
        snize.querySelectorAll('li.snize-product').forEach(function(li) {
            if (li.querySelector('.nw-new-badge')) return;
            var link = li.querySelector('a[href*="/products/"]');
            if (!link) return;
            var match = (link.getAttribute('href') || '').match(/\/products\/([^?#\/]+)/);
            if (!match) return;
            var handle = match[1];
            if (!window.nwNewProductHandles.has(handle)) return;
            var thumb = li.querySelector('.snize-thumbnail, .snize-thumbnail-wrapper');
            if (!thumb) return;
            var badge = document.createElement('span');
            badge.className = 'nw-new-badge';
            badge.textContent = /^fr/i.test(document.documentElement.lang || '') ? 'Nouveau' : 'New';
            thumb.appendChild(badge);
        });
    }

    function loadNewProductHandles() {
        if (nwNewHandlesFetched) { injectNewBadges(); return; }
        nwNewHandlesFetched = true;
        fetch('/products.json?tag=New&limit=250')
            .then(function(r) { return r.json(); })
            .then(function(data) {
                window.nwNewProductHandles = new Set(
                    (data.products || []).map(function(p) { return p.handle; })
                );
                injectNewBadges();
            })
            .catch(function() { window.nwNewProductHandles = new Set(); });
    }

    // Remove ribbon arrow from sale badge
    function fixSnizeLabels() {
        var snize = document.getElementById('snize_results');
        if (!snize) return;
        // Style the outer label as the pill
        snize.querySelectorAll('.snize-product-label').forEach(function(label) {
            label.style.setProperty('clip-path', 'none', 'important');
            label.style.setProperty('background', '#2A2A2A', 'important');
            label.style.setProperty('border-radius', '2px', 'important');
            label.style.setProperty('padding', '2px 6px', 'important');
            label.style.setProperty('border', 'none', 'important');
            label.style.setProperty('overflow', 'hidden', 'important');
            label.style.setProperty('color', '#fff', 'important');
            label.style.setProperty('font-size', '11px', 'important');
            label.style.setProperty('font-weight', '500', 'important');
            label.style.setProperty('line-height', '1.4', 'important');
            label.style.setProperty('letter-spacing', '0.02em', 'important');
            label.style.setProperty('text-transform', 'capitalize', 'important');
            // Make all direct children transparent so label bg shows through
            Array.from(label.children).forEach(function(child) {
                if (child.className && /right-arrow/i.test(child.className)) {
                    // Arrow decoration — hide it
                    child.style.setProperty('display', 'none', 'important');
                } else {
                    // Text child — make transparent so label bg shows
                    child.style.setProperty('clip-path', 'none', 'important');
                    child.style.setProperty('background', 'transparent', 'important');
                    child.style.setProperty('color', '#fff', 'important');
                    child.style.setProperty('padding', '0', 'important');
                }
            });
        });
    }

    // Reduce inter-card gap to half of Searchanise's default (1% → 0.5% sides, 2% → 1% bottom)
    function fixSnizeCardGaps() {
        if (window.innerWidth < 750) return;
        var snize = document.getElementById('snize_results');
        if (!snize) return;
        var ul = snize.querySelector('ul.snize-search-results-content');
        if (ul) ul.style.setProperty('margin-left', '-0.5%', 'important');
        var colMap = { 'snize-five-columns': 5, 'snize-four-columns': 4, 'snize-three-columns': 3 };
        Object.keys(colMap).forEach(function(cls) {
            snize.querySelectorAll('.' + cls + ' li.snize-product').forEach(function(li) {
                li.style.setProperty('width', 'calc(100% / ' + colMap[cls] + ' - 1%)', 'important');
                li.style.setProperty('margin', '0 0.5% 1% 0.5%', 'important');
            });
        });
    }

    // Initial run after Searchanise first loads; watchYotpoStars MutationObserver handles all subsequent re-runs
    document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function() {
            fixYotpoCardStars();
            fixProductInfoReviewState();
            fixSnizeAlignment();
            fixSnizeLabels();
            fixSnizeCardGaps();
            loadNewProductHandles();
        }, 600);
        setTimeout(fixYotpoCardStars, 1600);
        setTimeout(fixYotpoCardStars, 3200);
        setTimeout(fixProductInfoReviewState, 1600);
        setTimeout(fixProductInfoReviewState, 3200);
    });


    // Re-apply whenever Searchanise adds product cards or review elements
    // Deferred until DOM ready so document.body exists when we call observe()
    (function() {
        function watchYotpoStars() {
            var snize = document.getElementById('snize_results');
            if (!snize) {
                var bodyObserver = new MutationObserver(function(_, obs) {
                    if (document.getElementById('snize_results')) {
                        clearTimeout(bodyObserverTimeout);
                        obs.disconnect();
                        watchYotpoStars();
                    }
                });
                var bodyObserverTimeout = setTimeout(function() {
                    bodyObserver.disconnect();
                }, 15000);
                bodyObserver.observe(document.body, { childList: true, subtree: true });
                return;
            }
            var debounce;
            new MutationObserver(function(mutations) {
                var relevant = mutations.some(function(m) {
                    return Array.from(m.addedNodes).some(function(n) {
                        return n.nodeType === 1 && (
                            (n.classList && (n.classList.contains('snize-reviews') || n.classList.contains('snize-product'))) ||
                            (n.querySelector && (n.querySelector('.snize-reviews') || n.querySelector('svg')))
                        );
                    });
                });
                if (relevant) {
                    clearTimeout(debounce);
                    debounce = setTimeout(function() {
                        fixYotpoCardStars();
                        fixSnizeAlignment();
                        fixSnizeLabels();
                        injectNewBadges();
                        fixSnizeCardGaps();
                        // One delayed re-check catches Yotpo widget re-init after filter/search changes
                        setTimeout(fixYotpoCardStars, 800);
                        setTimeout(fixSnizeLabels, 400);
                        setTimeout(injectNewBadges, 400);
                        setTimeout(fixSnizeCardGaps, 400);
                    }, 80);
                }
            }).observe(snize, { childList: true, subtree: true });
        }
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', watchYotpoStars);
        } else {
            watchYotpoStars();
        }
    })();

    function fixYotpoLayout() {
        var container = document.querySelector('.yotpo-bottom-line-question-wrapper-vertical')
                     || document.querySelector('.yotpo-bottom-line-wrapper-vertical');
        if (container) {
            container.style.setProperty('min-width', '320px', 'important');
            container.style.setProperty('padding-left', '20px', 'important');
            container.style.setProperty('padding-right', '20px', 'important');
        }
        document.querySelectorAll('.yotpo-progress-bar-value-label').forEach(function(el) {
            el.style.setProperty('white-space', 'nowrap', 'important');
        });
    }
    setTimeout(fixYotpoLayout, 800);


function fixYotpoReviewStars() {
        document.querySelectorAll('.yotpo-review .yotpo-review-rating-title .yotpo-star-rating.yotpo-review-star-rating').forEach(function(el) {
            el.style.setProperty('display', 'inline-flex', 'important');
            el.style.setProperty('visibility', 'visible', 'important');
            el.style.setProperty('opacity', '1', 'important');
            el.querySelectorAll('*').forEach(function(child) {
                child.style.setProperty('display', 'inline-flex', 'important');
                child.style.setProperty('visibility', 'visible', 'important');
                child.style.setProperty('opacity', '1', 'important');
            });
        });
    }
    setTimeout(fixYotpoReviewStars, 1500);

    function selectFirstAvailableVariant() {
        var picker = document.querySelector('.product-information variant-picker');
        if (!picker) return;

        picker.querySelectorAll('fieldset').forEach(function(fieldset) {
            var current = fieldset.querySelector('input[data-current-checked="true"]');
            if (!current || current.dataset.optionAvailable !== 'false') return;

            var firstAvailable = fieldset.querySelector('input[data-option-available="true"]');
            if (!firstAvailable) return;

            firstAvailable.checked = true;
            firstAvailable.dataset.currentChecked = 'true';
            current.dataset.currentChecked = 'false';
            firstAvailable.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    // Fix gender toggle text color in size chart tab based on actual background color
    function fixSizeChartToggleColors() {
        var tab = document.querySelector('.nw-size-chart-tab');
        if (!tab) return;
        var buttons = tab.querySelectorAll('button, [role="tab"], a');
        buttons.forEach(function(btn) {
            if (btn.closest('table')) return; // skip table buttons
            var bg = window.getComputedStyle(btn).backgroundColor;
            // Parse RGB values
            var match = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);
            if (!match) return;
            var brightness = (parseInt(match[1]) * 299 + parseInt(match[2]) * 587 + parseInt(match[3]) * 114) / 1000;
            // Dark bg = selected → give it white box + black text
            // Light bg = unselected → transparent + white text
            if (brightness <= 128) {
                btn.style.setProperty('background-color', '#fff', 'important');
                btn.style.setProperty('color', '#000', 'important');
            } else {
                btn.style.setProperty('background-color', 'transparent', 'important');
                btn.style.setProperty('color', '#fff', 'important');
            }
        });
    }

    function initSwatchTooltips() {
        var tooltip = document.getElementById('nw-swatch-tooltip');
        if (!tooltip) {
            tooltip = document.createElement('div');
            tooltip.id = 'nw-swatch-tooltip';
            document.body.appendChild(tooltip);
        }

        document.querySelectorAll('.facets__inputs-list--swatches .variant-option--swatches').forEach(function(el) {
            if (el.dataset.tooltipInit) return;
            el.dataset.tooltipInit = '1';

            el.addEventListener('mouseenter', function(e) {
                var label = el.getAttribute('aria-label');
                if (!label) return;
                tooltip.textContent = label;
                tooltip.style.opacity = '1';
                var rect = el.getBoundingClientRect();
                tooltip.style.left = (rect.left + rect.width / 2 - tooltip.offsetWidth / 2) + 'px';
                tooltip.style.top = (rect.top - tooltip.offsetHeight - 6) + 'px';
            });

            el.addEventListener('mouseleave', function() {
                tooltip.style.opacity = '0';
            });
        });
    }

    // Searchanise sets inline !important widths on li items via JS after page load,
    // Searchanise handles its own column layout based on container width.
    // No override needed — nwSnizeForceFullWidth() above ensures the container
    // is full-width so Searchanise's own measurement picks the right column count.

    document.addEventListener('DOMContentLoaded', function() {
        moveElementToSizeVariant();
        initNativeLightbox();
        initGalleryInPlaceZoom();
        if (new URLSearchParams(window.location.search).has('variant')) {
            selectFirstAvailableVariant();
        }
        initSwatchTooltips();
        // Short delay for initial variant filtering to complete
        setTimeout(syncMobileDots, 200);
        setTimeout(fixSizeChartToggleColors, 800);
        setTimeout(fixSizeChartToggleColors, 2000);

        // Preload size chart app content: briefly activate the panel (hidden from view)
        // so the app fetches its data on page load instead of waiting for the user to click
        setTimeout(function() {
            var panel = document.querySelector('[id^="ai-tab-size-chart-"]');
            if (!panel || panel.classList.contains('active')) return;
            panel.style.cssText = 'position:absolute;visibility:hidden;pointer-events:none;';
            panel.classList.add('active');
            setTimeout(function() {
                panel.classList.remove('active');
                panel.style.cssText = '';
            }, 1500);
        }, 600);

        function resetSizeChartToFirstTab() {
            var tab = document.querySelector('.nw-size-chart-tab');
            if (!tab) return;
            var buttons = Array.from(tab.querySelectorAll('button, [role="tab"], a')).filter(function(b) {
                return !b.closest('table');
            });
            if (buttons.length === 0) return;

            // Read the sizing metafield (e.g. "women" or "men") set on the panel
            var panel = tab.closest('[data-sizing]');
            var sizing = panel ? panel.getAttribute('data-sizing') : '';

            // Find the button whose text matches the metafield value
            var target = null;
            if (sizing) {
                target = buttons.find(function(b) {
                    return b.textContent.trim().toLowerCase() === sizing;
                });
            }
            // Fall back to first button if no match found
            if (!target) target = buttons[0];

            target.click();
            setTimeout(fixSizeChartToggleColors, 50);
        }

        // Watch the size chart panel — fires once when content loads, then disconnects
        // to prevent the click itself from re-triggering the observer in a loop
        var sizeChartObserver = null;
        var sizeChartResetTimer = null;
        function watchSizeChartPanel() {
            var tab = document.querySelector('.nw-size-chart-tab');
            if (!tab || sizeChartObserver) return;
            sizeChartObserver = new MutationObserver(function() {
                clearTimeout(sizeChartResetTimer);
                sizeChartResetTimer = setTimeout(function() {
                    resetSizeChartToFirstTab();
                    fixSizeChartToggleColors();
                    // Disconnect after first reset so button clicks don't re-trigger the loop
                    if (sizeChartObserver) {
                        sizeChartObserver.disconnect();
                        sizeChartObserver = null;
                    }
                }, 300);
            });
            sizeChartObserver.observe(tab, { childList: true, subtree: true });
        }

        // Run when the Size Chart tab button is clicked (app loads content lazily)
        document.addEventListener('click', function(e) {
            var tabBtn = e.target.closest('[data-tab="size-chart"]');
            if (tabBtn) {
                watchSizeChartPanel();
                setTimeout(fixSizeChartToggleColors, 100);
                setTimeout(resetSizeChartToFirstTab, 300);
                setTimeout(fixSizeChartToggleColors, 500);
            }
            // Re-run when the gender toggle inside the size chart is clicked
            var toggleBtn = e.target.closest('.nw-size-chart-tab button, .nw-size-chart-tab [role="tab"], .nw-size-chart-tab a');
            if (toggleBtn && !toggleBtn.closest('table')) setTimeout(fixSizeChartToggleColors, 50);
        });

        document.addEventListener('variant:update', function() {
            setTimeout(function() {
                moveElementToSizeVariant();
                initNativeLightbox();
                initGalleryInPlaceZoom();
                syncMobileDots();
            }, 200);
        });

        // Prevent scroll jump when variant selection replaces the media gallery.
        // media-gallery.js calls replaceWith(newMediaGallery) on variant:update which briefly
        // collapses the image column height, causing browser scroll anchoring to jump to reviews.
        var nwVariantScrollY = null;
        document.addEventListener('change', function(e) {
            if (window.innerWidth < 750) return;
            if (e.target && e.target.closest && e.target.closest('.product-information variant-picker')) {
                nwVariantScrollY = window.scrollY;
            }
        }, true);
        document.addEventListener('variant:update', function() {
            if (nwVariantScrollY === null || nwVariantScrollY < 50) { nwVariantScrollY = null; return; }
            var savedY = nwVariantScrollY;
            nwVariantScrollY = null;
            requestAnimationFrame(function() {
                window.scrollTo({ top: savedY, behavior: 'instant' });
                requestAnimationFrame(function() {
                    window.scrollTo({ top: savedY, behavior: 'instant' });
                });
            });
        });

    });

    // ── Clone size chart into Shipping tab ──
    (function() {
        function nwCloneSizeChart() {
            var source = document.getElementById('tabs-s2');
            var targets = document.querySelectorAll('.nw-size-chart-tab [id="tabs-s2-clone"]');
            if (!source || source.children.length === 0) return;
            document.querySelectorAll('.nw-size-chart-tab').forEach(function(tab) {
                if (tab.contains(source)) return; // skip the original tab
                var clone = tab.querySelector('.nw-tabs-s2-clone');
                if (!clone) {
                    clone = document.createElement('div');
                    clone.className = 'nw-tabs-s2-clone';
                    tab.appendChild(clone);
                }
                clone.innerHTML = source.innerHTML;
            });
        }
        // Run after sizechart.js has had time to populate #tabs-s2
        setTimeout(nwCloneSizeChart, 1500);
        // Also re-clone on variant change
        document.addEventListener('variant:update', function() {
            setTimeout(nwCloneSizeChart, 500);
        });
    })();

    // ── Header: inject wishlist icon + separators (desktop only) ──
    function nwInjectHeader() {
        if (window.innerWidth < 750) return;
        var rightCol = document.querySelector('header-component .header__column--right');
        if (!rightCol) return;
        if (!rightCol.querySelector('header-actions')) return;

        function nwEnsureCartSep() {
            var actions = rightCol.querySelector('header-actions');
            if (!actions || actions.querySelector('.nw-sep-cart')) return;

            var cartDrawer = actions.querySelector('.cart-drawer');
            if (cartDrawer) {
                var cartSep = document.createElement('span');
                cartSep.className = 'nw-header-sep nw-sep-cart';
                cartSep.setAttribute('aria-hidden', 'true');
                actions.insertBefore(cartSep, cartDrawer);
            }
        }

        if (rightCol.querySelector('.nw-header-wish') && rightCol.querySelector('.nw-header-lang')) {
            nwEnsureCartSep();
            return;
        }

            // Inject inline search form
        if (!rightCol.querySelector('.nw-header-search')) {
            var form = document.createElement('form');
            form.action = '/pages/search-results-page';
            form.method = 'get';
            form.className = 'nw-header-search';
            form.setAttribute('role', 'search');
            form.innerHTML =
                '<input type="text" name="q" placeholder="Search..." autocomplete="off" class="nw-header-search__input" aria-label="Search">' +
                '<button type="submit" class="nw-header-search__btn" aria-label="Search">' +
                '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>' +
                '</button>';
            rightCol.appendChild(form);
        }

        function sep(n) {
            var s = document.createElement('span');
            s.className = 'nw-header-sep nw-sep-' + n;
            s.setAttribute('aria-hidden', 'true');
            return s;
        }

        var wish = document.createElement('a');
        wish.href = '/pages/swym-wishlist';
        wish.className = 'nw-header-wish';
        wish.setAttribute('aria-label', 'Wishlist');
        wish.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';

        // Language toggle before wish. The form is server rendered by
        // snippets/language-toggle.liquid (hosted in header-drawer.liquid) so its
        // active state is correct on first paint with no flicker. This column is
        // built in JS, not Liquid, so all we do here is copy that form in.
        // Clone rather than move: this function re-runs when the MutationObserver
        // sees Horizon re-render the header, and moving would empty the host so
        // the second pass would insert an empty container. The clone drops the id
        // so the hidden original keeps it and we do not duplicate one.
        var langWrap = document.createElement('div');
        langWrap.className = 'nw-header-lang';
        var langSrc = document.querySelector('#nw-lang-desktop-host .nw-lang-toggle');
        if (langSrc) {
            var langForm = langSrc.cloneNode(true);
            langForm.removeAttribute('id');
            langWrap.appendChild(langForm);
        }
        rightCol.appendChild(langWrap);
        rightCol.appendChild(sep(4));

        // sep(3) between wish and header-actions (no separator before wish)
        rightCol.appendChild(wish);
        rightCol.appendChild(sep(3));

        // sep-cart: inside header-actions before .cart-drawer
        nwEnsureCartSep();

        // Re-inject if header-component re-renders and removes our elements
        new MutationObserver(function() {
            var missingWish = !rightCol.querySelector('.nw-header-wish');
            var missingLang = !rightCol.querySelector('.nw-header-lang');
            nwEnsureCartSep();
            if (missingWish || missingLang) {
                nwInjectHeader();
            }
        }).observe(rightCol, { childList: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() { setTimeout(nwInjectHeader, 100); });
    } else {
        setTimeout(nwInjectHeader, 100);
    }

    // ── Mobile: keep header visible when drawer is open (X button fix) ──
    (function() {
        var headerEl = document.getElementById('header-component');
        var drawerDetails = document.getElementById('Details-menu-drawer-container');
        if (!headerEl || !drawerDetails) return;

        var observer = new MutationObserver(function() {
            if (drawerDetails.hasAttribute('open')) {
                headerEl.classList.add('nw-drawer-open');
            } else {
                headerEl.classList.remove('nw-drawer-open');
            }
        });
        observer.observe(drawerDetails, { attributes: true, attributeFilter: ['open'] });
    })();

    // ── Desktop menu: remove native hover tooltips from Globo/main nav links ──
    (function() {
        function nwRemoveHeaderMenuTooltips() {
            var headerEl = document.getElementById('header-component');
            if (!headerEl) return;

            headerEl.querySelectorAll('.nw-native-header-menu [title], nav[header-menu] [title]').forEach(function(el) {
                el.removeAttribute('title');
            });
        }

        nwRemoveHeaderMenuTooltips();
        window.addEventListener('load', nwRemoveHeaderMenuTooltips);
        document.addEventListener('shopify:section:load', function() {
            setTimeout(nwRemoveHeaderMenuTooltips, 50);
        });

        var headerEl = document.getElementById('header-component');
        if (headerEl) {
            new MutationObserver(nwRemoveHeaderMenuTooltips).observe(headerEl, {
                childList: true,
                subtree: true,
                attributes: true,
                attributeFilter: ['title']
            });
        }
    })();

    // ── Desktop menu contrast: white on transparent hero, black on white sticky header ──
    (function() {
        function nwParseRgb(color) {
            var match = color && color.match(/rgba?\(([^)]+)\)/);
            if (!match) return null;

            var parts = match[1].split(',').map(function(part) {
                return parseFloat(part.trim());
            });

            return {
                r: parts[0] || 0,
                g: parts[1] || 0,
                b: parts[2] || 0,
                a: parts.length > 3 ? parts[3] : 1
            };
        }

        function nwIsLightSolidBackground(color) {
            var rgba = nwParseRgb(color);
            if (!rgba || rgba.a < 0.85) return false;

            var luminance = (rgba.r * 0.299) + (rgba.g * 0.587) + (rgba.b * 0.114);
            return luminance > 210;
        }

        function nwUpdateHeaderContrastState() {
            var headerEl = document.getElementById('header-component');
            if (!headerEl) return;

            var isTransparentAtTop = headerEl.hasAttribute('transparent') && window.scrollY <= 2;
            var headerRow = headerEl.querySelector('.header__row--top');
            var rowColor = headerRow ? getComputedStyle(headerRow).backgroundColor : '';
            var headerColor = getComputedStyle(headerEl).backgroundColor;
            var hasLightBg = nwIsLightSolidBackground(rowColor) || nwIsLightSolidBackground(headerColor);

            headerEl.classList.toggle('nw-transparent-at-top', isTransparentAtTop);
            headerEl.classList.toggle('nw-header-light-bg', !isTransparentAtTop && hasLightBg);

            // Mobile fix: when transparent header is at its natural top position, mobile scroll
            // momentum can fire a downward scroll event that sets data-sticky-state='idle' (opacity:0).
            // Reset back to 'inactive' whenever the header is both transparent and sitting at top.
            if (headerEl.hasAttribute('transparent') && headerEl.dataset.stickyState === 'idle') {
                if (headerEl.getBoundingClientRect().top >= 0) {
                    headerEl.dataset.stickyState = 'inactive';
                }
            }
        }

        function nwScheduleHeaderContrastState() {
            window.requestAnimationFrame(nwUpdateHeaderContrastState);
        }

        nwScheduleHeaderContrastState();
        window.addEventListener('scroll', nwScheduleHeaderContrastState, { passive: true });
        window.addEventListener('resize', nwScheduleHeaderContrastState);
        document.addEventListener('shopify:section:load', function() {
            setTimeout(nwScheduleHeaderContrastState, 50);
        });

        // MutationObserver catches the idle→opacity:0 case even when the user has stopped
        // scrolling (no scroll events fire). Horizon sets data-sticky-state='idle' 150ms after
        // the last scroll-down event; if the header is already at the top of the page at that
        // moment, we immediately flip it back to 'inactive' so opacity:0 never renders.
        (function() {
            var headerEl = document.getElementById('header-component');
            if (!headerEl || !headerEl.hasAttribute('transparent')) return;
            new MutationObserver(function(mutations) {
                mutations.forEach(function(mutation) {
                    if (
                        mutation.attributeName === 'data-sticky-state' &&
                        headerEl.dataset.stickyState === 'idle' &&
                        headerEl.getBoundingClientRect().top >= 0
                    ) {
                        headerEl.dataset.stickyState = 'inactive';
                    }
                });
            }).observe(headerEl, { attributes: true, attributeFilter: ['data-sticky-state'] });
        })();
    })();

    // ── Mobile: inject search icon inside header-actions before cart ──
    function nwInjectMobileSearch() {
        if (window.innerWidth >= 750) return;
        var actions = document.querySelector('header-component .header__column--right header-actions');
        if (!actions) return;
        if (actions.querySelector('.nw-mobile-search-btn')) return;

        var btn = document.createElement('button');
        btn.className = 'nw-mobile-search-btn';
        btn.setAttribute('aria-label', 'Search');
        btn.setAttribute('type', 'button');
        btn.setAttribute('data-wg-notranslate', '');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
        btn.addEventListener('click', function() {
            // Trigger the theme's search-modal component via its own showDialog method
            // so that Searchanise's hooks on that component fire correctly.
            var searchModal = document.getElementById('search-modal');
            if (searchModal && typeof searchModal.showDialog === 'function') {
                searchModal.showDialog();
                return;
            }
            // Fallback: dispatch the event the theme's search button uses
            if (searchModal) {
                searchModal.dispatchEvent(new CustomEvent('showDialog', { bubbles: true }));
                return;
            }
        });

        var cartDrawer = actions.querySelector('.cart-drawer');
        if (cartDrawer) {
            actions.insertBefore(btn, cartDrawer);
        } else {
            actions.prepend(btn);
        }

        new MutationObserver(function() {
            if (!actions.querySelector('.nw-mobile-search-btn')) nwInjectMobileSearch();
        }).observe(actions, { childList: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() { setTimeout(nwInjectMobileSearch, 200); });
    } else {
        setTimeout(nwInjectMobileSearch, 200);
    }

    // ── Mobile product slideshow height: retired ──
    // nwDynamicSlideHeight() used to write an inline height on slideshow-slides (initial-load
    // writes, plus aria-hidden + variant:update handlers). The mobile gallery wrapper is now
    // pinned in CSS via --nw-gallery-ratio (see nw-custom.css + product-information.liquid), so
    // any JS height write would fight the fixed wrapper and get clipped mid-swipe. Removed whole.

    // Mobile gallery height is fully server-side now (Phase 3): the box is fixed to the
    // group's dominant ratio via --nw-group-modal-ratio, so the active-slide follower — and the
    // scrollend/350ms backstop that kept its write off the in-flight scroll — are both gone.

    // ── Product image zoom overlay ──
    function nwImageZoom() {
        if (document.querySelector('zoom-dialog')) return;

        var overlay = document.createElement('div');
        overlay.className = 'nw-zoom-overlay';
        overlay.setAttribute('role', 'dialog');
        overlay.setAttribute('aria-modal', 'true');
        overlay.setAttribute('aria-label', 'Product image zoom');
        overlay.innerHTML =
            '<div class="nw-zoom-overlay__inner">' +
                '<img class="nw-zoom-overlay__img" src="" alt="">' +
            '</div>' +
            '<button class="nw-zoom-overlay__close" aria-label="Close zoom">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
            '</button>' +
            '<div class="nw-zoom-overlay__counter"></div>' +
            '<span class="nw-zoom-overlay__hint" style="opacity:0">Pinch to zoom · Swipe to navigate</span>';
        document.body.appendChild(overlay);

        var overlayImg = overlay.querySelector('.nw-zoom-overlay__img');
        var closeBtn   = overlay.querySelector('.nw-zoom-overlay__close');
        var counter    = overlay.querySelector('.nw-zoom-overlay__counter');
        var hint       = overlay.querySelector('.nw-zoom-overlay__hint');
        var hintShown  = false;
        var gallery    = [];
        var currentIdx = 0;

        function getHighResSrc(src) {
            return src.replace(/([?&]width=)\d+/, function(match, prefix) {
                return prefix + '1200';
            });
        }

        function showSlide(idx, dir) {
            if (!gallery[idx]) return;
            currentIdx = idx;

            // Slide out current image
            overlayImg.style.transition = 'opacity 0.18s ease, transform 0.18s ease';
            overlayImg.style.opacity = '0';
            overlayImg.style.transform = dir === 'next' ? 'translateX(-40px)' : dir === 'prev' ? 'translateX(40px)' : 'none';

            // Load next image then slide in
            var item = gallery[idx];
            var tmp = new Image();
            tmp.onload = function() {
                overlayImg.src = tmp.src;
                overlayImg.alt = item.alt;
                overlayImg.style.transition = 'none';
                overlayImg.style.transform = dir === 'next' ? 'translateX(40px)' : dir === 'prev' ? 'translateX(-40px)' : 'none';
                requestAnimationFrame(function() {
                    requestAnimationFrame(function() {
                        overlayImg.style.transition = 'opacity 0.18s ease, transform 0.18s ease';
                        overlayImg.style.opacity = '1';
                        overlayImg.style.transform = 'translateX(0)';
                    });
                });
            };
            tmp.src = getHighResSrc(item.src);

            // Update counter
            counter.textContent = gallery.length > 1 ? (idx + 1) + ' / ' + gallery.length : '';
        }

        function openZoom(imgs, startIdx) {
            gallery = Array.from(imgs).map(function(img) {
                return { src: img.currentSrc || img.src, alt: img.alt || '' };
            });
            overlayImg.style.transition = 'none';
            overlayImg.style.opacity = '1';
            overlayImg.style.transform = 'none';
            showSlide(startIdx, null);
            overlay.classList.add('is-open');
            document.body.style.overflow = 'hidden';
            if (!hintShown) {
                hintShown = true;
                hint.style.opacity = '1';
                setTimeout(function() { hint.style.opacity = '0'; }, 2500);
            }
        }

        function closeZoom() {
            overlay.classList.remove('is-open');
            document.body.style.overflow = '';
            var meta = document.querySelector('meta[name="viewport"]');
            if (meta) {
                var orig = meta.content.replace(/,?\s*maximum-scale=\S*/gi, '');
                meta.content = orig + ', maximum-scale=1';
                setTimeout(function() { meta.content = orig; }, 80);
            }
            setTimeout(function() { overlayImg.src = ''; }, 260);
        }

        // Swipe navigation
        var swipeStartX = 0, swipeStartY = 0, swipeStartTime = 0, activeTouches = 0;
        overlay.addEventListener('touchstart', function(e) {
            activeTouches = e.touches.length;
            if (activeTouches === 1) {
                swipeStartX    = e.touches[0].clientX;
                swipeStartY    = e.touches[0].clientY;
                swipeStartTime = Date.now();
            }
        }, { passive: true });
        overlay.addEventListener('touchend', function(e) {
            if (activeTouches > 1 || gallery.length < 2) { activeTouches = 0; return; }
            var dx = e.changedTouches[0].clientX - swipeStartX;
            var dy = e.changedTouches[0].clientY - swipeStartY;
            var dt = Date.now() - swipeStartTime;
            if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && dt < 400) {
                if (dx < 0) showSlide((currentIdx + 1) % gallery.length, 'next');
                else        showSlide((currentIdx - 1 + gallery.length) % gallery.length, 'prev');
            }
            activeTouches = 0;
        }, { passive: true });

        closeBtn.addEventListener('click', closeZoom);
        // Only close when tapping the dark background, not the image
        overlay.addEventListener('click', function(e) {
            if (e.target === overlay) closeZoom();
        });
        document.addEventListener('keydown', function(e) {
            if (!overlay.classList.contains('is-open')) return;
            if (e.key === 'Escape') closeZoom();
            if (e.key === 'ArrowRight' && gallery.length > 1) showSlide((currentIdx + 1) % gallery.length, 'next');
            if (e.key === 'ArrowLeft'  && gallery.length > 1) showSlide((currentIdx - 1 + gallery.length) % gallery.length, 'prev');
        });

        function bindImages() {
            var slides = document.querySelectorAll('.product-information__media slideshow-slide');
            var imgs   = Array.from(slides).map(function(s) { return s.querySelector('img'); }).filter(Boolean);
            imgs.forEach(function(img, idx) {
                if (img.dataset.zoomBound) return;
                img.dataset.zoomBound = '1';
                img.addEventListener('click', function(e) {
                    // Re-query at click time so variant changes are reflected
                    var freshSlides = document.querySelectorAll('.product-information__media slideshow-slide');
                    var freshImgs   = Array.from(freshSlides).map(function(s) { return s.querySelector('img'); }).filter(Boolean);
                    var clickedImg  = e.currentTarget;
                    var clickedSlide = clickedImg.closest('slideshow-slide');
                    var freshIdx = freshImgs.indexOf(clickedImg);

                    if (freshIdx < 0 && clickedSlide) {
                        var freshSlideList = Array.from(freshSlides);
                        freshIdx = freshSlideList.indexOf(clickedSlide);
                    }

                    if (freshIdx < 0) {
                        var clickedSrc = clickedImg.currentSrc || clickedImg.src;
                        freshIdx = freshImgs.findIndex(function(freshImg) {
                            return (freshImg.currentSrc || freshImg.src) === clickedSrc;
                        });
                    }

                    openZoom(freshImgs, freshIdx >= 0 ? freshIdx : idx);
                });
            });
        }

        bindImages();
        document.addEventListener('variant:update', function() { setTimeout(bindImages, 300); });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', nwImageZoom);
    } else {
        nwImageZoom();
    }


    // ── Language toggle: correct return_to at submit time ──
    // Shopify generates the localization form's return_to from the request that
    // produced the markup. Horizon re-renders the header through the Section
    // Rendering API, so a form that came from that response carries
    // return_to=/fr?section_id=sections--...__header_section, and submitting it
    // sends the visitor to raw unstyled section markup. Rewrite it from the live
    // location at submit time, which is correct however the markup was produced.
    // Real params such as ?variant= are kept; Shopify's internal ones are dropped.
    document.addEventListener('submit', function (e) {
        var form = e.target;
        if (!form || !form.classList || !form.classList.contains('nw-lang-toggle')) return;
        var input = form.querySelector('input[name="return_to"]');
        if (!input) return;
        var params;
        try {
            params = new URLSearchParams(window.location.search);
        } catch (err) {
            return; // leave Shopify's value alone rather than risk a bad one
        }
        ['section_id', '_fd', 'pb', 'shpxid'].forEach(function (k) { params.delete(k); });
        var qs = params.toString();
        input.value = window.location.pathname + (qs ? '?' + qs : '');
    }, true);

    // ── Desktop nav: accent hover + underline ──
    // Uses event delegation so it targets the live element after Horizon re-renders on pointerenter.
    (function() {
        if (!window.matchMedia('(min-width: 750px)').matches) return;
        function nwNavLink(target) {
            if (!target || !target.closest) return null;
            var link = target.closest('.menu-list__link, .mega-menu__link');
            if (!link || link.closest('.menu-drawer') || link.querySelector('.mega-menu__link-image')) return null;
            return link;
        }
        document.addEventListener('mouseover', function(e) {
            var link = nwNavLink(e.target);
            if (!link) return;
            link.style.setProperty('color', '#E61A7A', 'important');
            link.style.setProperty('text-decoration', 'underline');
            link.style.setProperty('text-decoration-color', '#E61A7A');
            link.style.setProperty('text-underline-offset', '3px');
            var span = link.querySelector('.menu-list__link-title');
            if (span) span.style.setProperty('color', '#E61A7A', 'important');
        });
        document.addEventListener('mouseout', function(e) {
            var link = nwNavLink(e.target);
            if (!link) return;
            if (link.contains(e.relatedTarget)) return;
            link.style.removeProperty('color');
            link.style.removeProperty('text-decoration');
            link.style.removeProperty('text-decoration-color');
            link.style.removeProperty('text-underline-offset');
            var span = link.querySelector('.menu-list__link-title');
            if (span) span.style.removeProperty('color');
        });
    })();

/* ==========================================================================
   Returns policy modal — trust-ticker returns bullet
   Single state. The bullet is suppressed on final-sale products upstream in
   blocks/trust-ticker.liquid, so there is no final-sale branch here.
   ========================================================================== */
(function () {
    'use strict';

    // ─── CONFIG ────────────────────────────────────────────────────────────
    var POLICY_URL = '/pages/return-policy';
    var SHOW_WINDOWS_LABEL = false;  // true = show 'Your options depend on when you return'

    var COPY = {
        // Fallback only. The heading is taken from the bullet itself at open
        // time so its casing can never drift from the perk3_lead setting.
        headingFallback: '60-Day Returns',
        introBefore: 'Returns are accepted within 60 days of purchase for a size or colour exchange, store credit, or refund. ',
        introLink: 'Conditions apply',
        introAfter: '.',
        windowsLabel: 'Your options depend on when you return',
        rows: [
            { range: 'Days 1 to 21',  detail: 'refund, store credit, or size/colour exchange.' },
            { range: 'Days 22 to 60', detail: 'store credit or size/colour exchange.' }
        ],
        exclusions: 'Clearance, costumes, pole wear bottoms, and lingerie bottoms are final sale.',
        policyLink: 'Read the full policy'
    };
    // ───────────────────────────────────────────────────────────────────────

    var dialog = null, lastTrigger = null;
    var esc = function (s) {
        return String(s).replace(/[&<>"']/g, function (c) {
            return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
        });
    };

    function ensureDialog() {
        if (dialog) return dialog;                    // injected once into body
        dialog = document.createElement('dialog');
        dialog.className = 'sf-returns-dialog';
        dialog.setAttribute('aria-labelledby', 'sf-returns-heading');
        document.body.appendChild(dialog);
        // A click landing on the dialog itself is the backdrop; the panel child
        // absorbs clicks inside it.
        dialog.addEventListener('click', function (e) { if (e.target === dialog) closeIt(); });
        dialog.addEventListener('close', restore);    // covers ESC and close()
        return dialog;
    }

    function render(heading) {
        var h = '';
        h += '<div class="sf-returns-panel" role="document" tabindex="-1">';
        h +=   '<button type="button" class="sf-returns-close" aria-label="Close">'
             +   '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" '
             +   'stroke-width="2" stroke-linecap="round" aria-hidden="true">'
             +   '<path d="M18 6 6 18M6 6l12 12"/></svg>'
             + '</button>';
        h +=   '<h2 class="sf-returns-heading" id="sf-returns-heading">' + esc(heading) + '</h2>';
        h +=   '<p class="sf-returns-body">' + esc(COPY.introBefore)
             +   '<a class="sf-returns-inline-link" href="' + POLICY_URL + '">' + esc(COPY.introLink) + '</a>'
             +   esc(COPY.introAfter) + '</p>';
        if (SHOW_WINDOWS_LABEL) {
            h += '<p class="sf-returns-label">' + esc(COPY.windowsLabel) + '</p>';
        }
        // One grid, cells as direct children, so both rows share a single column track
        // and the detail text starts at the same x on every row.
        h +=   '<div class="sf-returns-windows">';
        COPY.rows.forEach(function (r) {
            h += '<span class="sf-returns-window__range">' + esc(r.range) + '</span>'
               + '<span class="sf-returns-window__detail">' + esc(r.detail) + '</span>';
        });
        h +=   '</div>';
        h +=   '<p class="sf-returns-exclusions">' + esc(COPY.exclusions) + '</p>';
        h +=   '<div class="sf-returns-footer">'
             +   '<a class="sf-returns-policy" href="' + POLICY_URL + '">' + esc(COPY.policyLink) + '</a>'
             + '</div>';
        h += '</div>';
        dialog.innerHTML = h;
        dialog.querySelector('.sf-returns-close').addEventListener('click', closeIt);
    }

    function openIt(trigger) {
        var d = ensureDialog();
        lastTrigger = trigger;

        var lead = trigger.querySelector('.trust-ticker__lead');
        var heading = (lead && lead.textContent.trim()) || COPY.headingFallback;
        render(heading);

        lockScroll();

        if (typeof d.showModal === 'function') d.showModal();   // focus trap + ESC free
        else d.setAttribute('open', '');

        // Move focus off the close button: showModal() lands on the first focusable
        // child, and its focus ring reads as a pink box clipping the rounded corner.
        // The panel takes focus instead, so a screen reader starts at the heading.
        var panel = d.querySelector('.sf-returns-panel');
        if (panel) panel.focus();
    }

    function closeIt() { if (dialog && dialog.open) dialog.close(); else restore(); }

    // showModal() hides the document scrollbar, so the page reflows ~15px wider and
    // everything shifts left. Compensate with padding-right on body. Nothing else on the
    // PDP needs it: header-component is position:static, .product-details is sticky (in
    // flow, so it reflows with the document), and the only full-width position:fixed
    // elements are hidden app overlays (Swym, Rebuy cart backdrop, Attentive) which must
    // not be padded. sbw is 0 under overlay scrollbars (macOS default, mobile) — guarded
    // so we are not writing padding-right: 0px churn.
    // Save and restore rather than clear: other components lock scroll the same way
    // (Attentive's popup sets overflow:hidden inline on documentElement). Blanket-
    // clearing on close unlocked the page underneath a still-open Attentive popup.
    var prevHtmlOverflow = null, prevBodyPadRight = null;

    function lockScroll() {
        var sbw = window.innerWidth - document.documentElement.clientWidth;
        prevHtmlOverflow = document.documentElement.style.overflow;
        if (sbw > 0) {
            prevBodyPadRight = document.body.style.paddingRight;
            document.body.style.paddingRight = sbw + 'px';
        }
        document.documentElement.style.overflow = 'hidden';
    }

    function unlockScroll() {
        document.documentElement.style.overflow = prevHtmlOverflow || '';
        if (prevBodyPadRight !== null) document.body.style.paddingRight = prevBodyPadRight;
        prevHtmlOverflow = null;
        prevBodyPadRight = null;
    }

    function restore() {
        unlockScroll();
        if (lastTrigger && document.contains(lastTrigger)) lastTrigger.focus();
        lastTrigger = null;
    }

    // Delegated on document: Horizon morphs the product-details region on variant
    // change, so a directly bound listener is a coin flip.
    document.addEventListener('click', function (e) {
        var t = e.target && e.target.closest && e.target.closest('[data-sf-returns-trigger]');
        if (!t) return;
        e.preventDefault();
        openIt(t);
    });
})();

/* ==========================================================================
   Mobile search: raise the iOS keyboard on the FIRST tap of the search icon.

   iOS Safari only honours programmatic focus() while still inside the same
   synchronous call stack as the user gesture. The theme's dialog.js wraps
   dialog.showModal() in a requestAnimationFrame (measured: the dialog opens
   ~46ms after the tap), so the implicit focus showModal() gives the input
   lands OUTSIDE the gesture — desktop focuses fine, iOS shows a caret but no
   keyboard, and the user has to tap the field again.

   The input (#cmdk-input) is server-rendered and exists at tap time, but sits
   inside the closed <dialog>, which the UA styles display:none — and iOS also
   refuses to focus an element that is not being rendered. So, synchronously
   inside the tap: force the closed dialog renderable but imperceptible
   (display:block + fixed + opacity:0, no layout impact, no scroll jump),
   focus the input — keyboard rises — then let the theme's showDialog() run
   unchanged; when the dialog actually opens one frame later the temporary
   styles come off. showModal()'s own focusing lands on the same, already
   focused input, so the keyboard stays.

   Bound on document in the CAPTURE phase so it runs before the button's own
   handler (which calls showDialog) without touching that code. Desktop
   (>=750px) is untouched; nwSubmitSearchanise and the theme's predictive
   search bindings on this same input are untouched.
   ========================================================================== */
(function () {
    'use strict';

    // Scoped to header-component, not document: the header is the only place the
    // injected trigger can live, so this capture listener fires for header taps
    // only — it never runs for PDP taps that Rebuy/Swym/Attentive are listening
    // to. Capture on an ancestor still precedes the button's own handler, which
    // is the ordering the synchronous focus depends on. header-component is a
    // persistent custom element (the same anchor nwInjectMobileSearch relies on);
    // document is only a fallback if it is somehow absent.
    function nwBindFirstTapFocus() {
        var host = document.getElementById('header-component') || document;
        host.addEventListener('click', nwFirstTapFocus, true);
    }

    function nwFirstTapFocus(e) {
        if (window.innerWidth >= 750) return;
        var btn = e.target && e.target.closest && e.target.closest('.nw-mobile-search-btn');
        if (!btn) return;

        var modal = document.getElementById('search-modal');
        var dialog = modal && modal.querySelector('dialog');
        var input = dialog && dialog.querySelector('input[type="search"], input[name="q"]');
        if (!dialog || !input || dialog.open) return;

        // Make the closed dialog renderable, invisibly, in this same tick.
        var temp = ['display', 'position', 'top', 'left', 'opacity', 'pointer-events'];
        var prev = temp.map(function (p) { return dialog.style.getPropertyValue(p); });
        dialog.style.setProperty('display', 'block');
        dialog.style.setProperty('position', 'fixed');
        dialog.style.setProperty('top', '0');
        dialog.style.setProperty('left', '0');
        dialog.style.setProperty('opacity', '0');
        dialog.style.setProperty('pointer-events', 'none');

        // Same call stack as the gesture: this is the line that raises the keyboard.
        input.focus({ preventScroll: true });

        var cleaned = false;
        function cleanup() {
            if (cleaned) return;
            cleaned = true;
            temp.forEach(function (p, i) {
                if (prev[i]) dialog.style.setProperty(p, prev[i]);
                else dialog.style.removeProperty(p);
            });
            // If the dialog never opened (showDialog failed), do not leave an
            // invisible focused input behind.
            if (!dialog.open && document.activeElement === input) input.blur();
        }

        // Normal path: the theme opens the dialog on the next frame.
        modal.addEventListener('dialog:open', cleanup, { once: true });

        // Searchanise mounts its widget only on a POINTER event on the input —
        // its focus handler just calls hideThemeLiveSearch() (verified by reading
        // the jQuery event registry), which is why the first-tap panel rendered
        // completely empty: theme predictive hidden, snize never mounted. The
        // mobile bindings are mousedown/touchstart/touchend, plain jQuery
        // handlers with no isTrusted check, so a synthetic touchstart mounts the
        // widget (verified: #snize-instant-search-results renders into the open
        // dialog with the Popular Suggestions panel). Dispatch it once the
        // dialog is actually open so the widget measures its final geometry —
        // the keyboard does not depend on this event, only on the synchronous
        // focus above, and synthetic events are not gesture-gated.
        modal.addEventListener('dialog:open', function () {
            if (!window.Searchanise) return;
            input.dispatchEvent(new Event('touchstart', { bubbles: true, cancelable: true }));
        }, { once: true });
        // Fallback: never let the temporary styles outlive a failed open.
        setTimeout(cleanup, 1000);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', nwBindFirstTapFocus);
    } else {
        nwBindFirstTapFocus();
    }
})();
